import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  handle: ''
}

const mutations = {
  setHandle(state, handle) {
    state.handle = handle
  }
}

const getters = {
  handle: state => state.handle
}


export default new Vuex.Store({
  state,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/store.js